import React from "react";
import "./App.css";

function Footer() {

    return (
        <div className="footer">
            {/* <span className="creds">designed and developed by <a href="https://callumowen.co.uk" target="_blank" rel="noopener noreferrer">callum owen</a></span> */}
            <span className="creds">designed and developed by callum owen</span>
            <span className="copyright">© 2020 watchwhere</span>
        </div>
    );
}

export default Footer;
